<template>
  <address-component/>
</template>

<script>
import AddressComponent from '@/spa/components/board/address/BoardOfflineStoreManage';

export default {
  name: 'AddressPage',
  components: {
    AddressComponent,
  },
};
</script>



// WEBPACK FOOTER //
// src/spa/pages/operation/store/AddressPage.vue